import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    /* ── Host ────────────────────────────────────────────────────────────────── */
    :host {
      display: inline-flex;
      vertical-align: middle;
      margin: 0.25rem;
    }

    /* Overlay mode — wraps a child element */
    :host([data-overlay]) {
      position: relative;
      /* Extra top + right margin so the overflowing badge pill doesn't clip siblings */
      margin: 0.75rem 0.75rem 0.25rem 0.25rem;
    }

    /* ── Badge pill ──────────────────────────────────────────────────────────── */
    .uwc-badge {
      /* private severity tokens */
      --_bg:    var(--uwc-badge-primary-bg,    var(--uwc-color-primary, ${t.primary}));
      --_color: var(--uwc-badge-primary-color,  #ffffff);

      display: inline-flex;
      align-items: center;
      justify-content: center;
      /* em-based so the pill scales with its (token-driven) font size */
      min-width: 1.8em;
      height: 1.8em;
      padding: 0 0.5em;
      border-radius: var(--uwc-radius-full, ${t.radiusFull});
      background: var(--_bg);
      color: var(--_color);
      font-size: var(--uwc-badge-font-size, ${t.fontSizeXs});
      font-weight: ${t.fontWeightBold};
      font-family: var(--uwc-font-family, inherit);
      line-height: 1;
      white-space: nowrap;
      border: 2px solid var(--uwc-surface, #ffffff);
    }

    /* Dot — no value provided */
    .uwc-badge--dot {
      min-width: 0.5rem;
      width: 0.5rem;
      height: 0.5rem;
      padding: 0;
      border-radius: 50%;
      border: none;
    }

    /* ── Overlay position ────────────────────────────────────────────────────── */
    :host([data-overlay]) .uwc-badge {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
      z-index: 1;
    }

    /* ── Severity ────────────────────────────────────────────────────────────── */
    .uwc-badge--secondary {
      --_bg:    var(--uwc-badge-secondary-bg,    #64748b);
      --_color: var(--uwc-badge-secondary-color,  #ffffff);
    }
    .uwc-badge--success {
      --_bg:    var(--uwc-badge-success-bg,    #16a34a);
      --_color: var(--uwc-badge-success-color,  #ffffff);
    }
    .uwc-badge--info {
      --_bg:    var(--uwc-badge-info-bg,    #0284c7);
      --_color: var(--uwc-badge-info-color,  #ffffff);
    }
    .uwc-badge--warning {
      --_bg:    var(--uwc-badge-warning-bg,    #d97706);
      --_color: var(--uwc-badge-warning-color,  #ffffff);
    }
    .uwc-badge--danger {
      --_bg:    var(--uwc-badge-danger-bg,    #dc2626);
      --_color: var(--uwc-badge-danger-color,  #ffffff);
    }
    .uwc-badge--contrast {
      --_bg:    var(--uwc-badge-contrast-bg,    #1e293b);
      --_color: var(--uwc-badge-contrast-color,  #f8fafc);
    }

    /* ── Size variants ───────────────────────────────────────────────────────── */
    .uwc-badge--small {
      min-width: 1rem;
      height: 1rem;
      font-size: 0.6rem;
      padding: 0 0.25rem;
    }
    .uwc-badge--large {
      min-width: 1.5rem;
      height: 1.5rem;
      font-size: ${t.fontSizeSm};
      padding: 0 0.45rem;
    }
  `,
];
